import type { CSSProperties } from 'react';
import { Image, theme } from 'antd';
import { getPlatformLogoSrc } from '@/utils/constants';

interface PlatformIconEchoProps {
  name: string;
  style?: CSSProperties;
  fallback?: string | null;
}

/**
 * Renders a platform logo image for any platform name.
 * Unknown names use the default podcast image using `getPlatformLogoSrc`.
 */
export const PlatformIconEcho = ({ name, style, fallback = null }: PlatformIconEchoProps) => {
  const { token } = theme.useToken();
  const sourceUrl = fallback ?? getPlatformLogoSrc(name);
  const imageStyle: CSSProperties = {
    borderRadius: token.borderRadiusSM,
    objectFit: 'contain',
    display: 'block',
    ...style,
  };

  return (
    <Image
      src={sourceUrl}
      alt={`${name} logo`}
      preview={false}
      width={token.size}
      height={token.size}
      style={imageStyle}
    />
  );
};
